import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { BoxConditionIcon, TruckIcon, MapMarkerIcon } from '../../../../assets';
import { theme } from '../../../../theme';
import { ReserveBar } from '../../../reserveBar';
import { Timer } from '../../../timer';
import { WatchButton } from '../../../watchButton';
import { SearchCard } from '../types';
import {
  Price,
  GrayUIText,
  Title,
  StyledBadge,
  ResponsiveImageContainer,
  Image,
  BottomContent,
  WatchButtonContainer,
  ReserveBarTimerWrapper,
  StyledDeliveryPill,
  SearchCardContainerBase,
  StyledLotBadge,
} from './styles';

const Container = styled(SearchCardContainerBase)`
  width: 100%;
  min-width: 344px;
  min-height: 136px;
  display: grid;
  grid-template-columns: 165px 178px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings[2].rem};
  margin: ${theme.spacings[3].rem} ${theme.spacings[2].rem};
`;
const BadgesContainer = styled.div`
  position: absolute;
  left: 0;
  top: ${theme.spacings[1].rem};
  display: flex;
  flex-direction: column;
`;
export const BaseResponsiveSearchCard: React.FC<
  PropsWithChildren<Partial<SearchCard<'Default'>>>
> = ({
  badgeLabel,
  badgeType,
  imageUrl,
  title,
  price,
  condition,
  location,
  isDelivery,
  href,
  shippingDiscount,
  children,
  lotId,
  isWatched,
  onWatchButtonClick,
  onClick,
  timeLeft,
  isWatchable,
  reserveStatus,
  reserveStatusMapping,
  badges,
}) => {
  return (
    <Container
      key={lotId?.toString()}
      id={lotId?.toString()}
      href={href}
      onClick={onClick}
    >
      <ResponsiveImageContainer>
        {(badgeLabel || badges) && (
          <BadgesContainer>
            {badgeLabel && <StyledBadge label={badgeLabel} type={badgeType} />}
            {badges &&
              badges.length > 0 &&
              badges.map((badge) => (
                <StyledLotBadge
                  label={badge.label}
                  href={badge.url}
                  altText={badge.title}
                />
              ))}
          </BadgesContainer>
        )}

        {!!shippingDiscount && (
          <StyledDeliveryPill
            backgroundColor={theme.colors.primary.graysBlue}
            color={theme.colors.primary.white}
          >
            {shippingDiscount}
          </StyledDeliveryPill>
        )}
        {isWatchable === true && isWatched !== undefined && (
          <WatchButtonContainer>
            <WatchButton
              lotId={lotId}
              onClick={onWatchButtonClick}
              width={24}
              filled={isWatched}
            />
          </WatchButtonContainer>
        )}
        <Image src={imageUrl} alt="" />
      </ResponsiveImageContainer>
      {children ? (
        children
      ) : (
        <Content className="content">
          <Title>{title}</Title>
          <ReserveBarTimerWrapper>
            {reserveStatus && (
              <ReserveBar
                reserveStatus={reserveStatus}
                reserveStatusMapping={reserveStatusMapping}
              />
            )}
            <Timer format="short" closingTime={timeLeft} />
          </ReserveBarTimerWrapper>
          <Price>{price}</Price>
          <BottomContent>
            <GrayUIText>
              <BoxConditionIcon
                width={16}
                fill={theme.colors.neutrals.solidGrays[3]}
              />
              {condition}
            </GrayUIText>
            <GrayUIText>
              {isDelivery ? (
                (condition as string).length < 15 && (
                  <>
                    <TruckIcon
                      width={16}
                      fill={theme.colors.neutrals.solidGrays[3]}
                    />
                    Delivery
                  </>
                )
              ) : (
                <>
                  <MapMarkerIcon
                    width={16}
                    fill={theme.colors.neutrals.solidGrays[3]}
                  />
                  {location}
                </>
              )}
            </GrayUIText>
          </BottomContent>
        </Content>
      )}
    </Container>
  );
};
